import {
  OKTAUserServiceFlagEnum,
  OKTAUserTypeEnum,
} from "@app/hooks/useUserInfo";
import { LabelCardIconVariety } from "@elements/Icon/LabelCardIcon";
import hasServiceFlag from "@helper/hasServiceFlag";
import { getUserType } from "@src/app/hooks/useUserInfo.ts";
import { useEffect, useState } from "react";

/**
 * Custom hook to determine whether to show the premium label based on content access and user type.
 * @param contentAccess - The content access level (FREE, PREMIUM, REGISTERED_USER).
 * @returns An object containing a boolean indicating whether to show the premium label for the current user.
 */
export function useAccessPremiumLabel(contentAccess?: LabelCardIconVariety) {
  const [showPremiumLabel, setShowPremiumLabel] = useState(false);
  useEffect(() => {
    const userType = getUserType();

    const shouldShow =
      contentAccess === LabelCardIconVariety.PREMIUM &&
      (userType === OKTAUserTypeEnum.SUBSCRIBER ||
        hasServiceFlag(OKTAUserServiceFlagEnum.BH_ONLINE));

    setShowPremiumLabel(shouldShow);
  }, [contentAccess]);

  return { showPremiumLabel };
}
